module.exports = __webpack_public_path__ + "assets/img/652900.722bb025.png";